import { useEffect } from "react";

const ZENDESK_SCRIPT_ID = "ze-snippet";
const ZENDESK_SCRIPT_SRC =
  "https://static.zdassets.com/ekr/snippet.js?key=63c40e5e-4127-409d-aca5-107ef45b609f";

const ZendeskWidget = () => {
  useEffect(() => {
    // Prevent duplicate script injection
    if (!document.getElementById(ZENDESK_SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = ZENDESK_SCRIPT_ID;
      script.src = ZENDESK_SCRIPT_SRC;
      script.async = true;

      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default ZendeskWidget;